import { IconSizes, IconColors } from '@/constants/iconTypes';
import { Icon } from '@mui/material';

interface IconProps {
  icon_name: string;
  size?: IconSizes;
  color?: IconColors;
  filled?: boolean;
}

const fontSizeMap = {
  small: 24,
  medium: 36,
  large: 48,
};

export const InertIcon = ({ icon_name, size, color, filled }: IconProps) => {
  return (
    <Icon
      color={color !== IconColors.TEXT ? color : undefined}
      sx={{
        fontSize: fontSizeMap[size ?? 'small'],
        fontFamily: 'Material Symbols Outlined',
        color: color === IconColors.TEXT ? 'text.primary' : undefined,
        fontVariationSettings: filled ? '"FILL" 1' : '"FILL" 0',
      }}
    >
      {icon_name}
    </Icon>
  );
};
